import { PollSlideTypes } from '../../../../../../db/types';
import AutoPollOverlay from './AutoPollOverlay';
import BarGraph from './BarGraph';
import ManualPollOverlay from './ManualPollOverlay';
import PieChart from './PieChart';
import { publishedQuestionOptionsClasses, Root } from './styles';
import usePublishedQuestionOptions, { UsePublishedQuestionOptions } from './vm';

export interface PublishedQuestionOptionsProps extends UsePublishedQuestionOptions {
  className?: string;
}

const PublishedQuestionOptions = ({ className, ...vmProps }: PublishedQuestionOptionsProps) => {
  const { slideType, publishedOptions, canSeeResults } = usePublishedQuestionOptions(vmProps);

  if (!slideType) return null;

  return (
    <Root className={className}>
      {slideType === PollSlideTypes.BAR_GRAPH && (
        <BarGraph
          publishedOptions={publishedOptions}
          canSeeResults={canSeeResults}
          className={publishedQuestionOptionsClasses.barGraph}
        />
      )}
      {slideType === PollSlideTypes.PIE_CHART && (
        <PieChart
          publishedOptions={publishedOptions}
          canSeeResults={canSeeResults}
          className={publishedQuestionOptionsClasses.pieChart}
        />
      )}
      <AutoPollOverlay canSeeResults={canSeeResults} />
      <ManualPollOverlay />
    </Root>
  );
};

export default PublishedQuestionOptions;
